import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

import { logoUrl } from '@/utils/urls';

export type PageHeaderMetaProps = {
    readonly canonical: string;
    readonly children?: ReactNode;
    readonly description?: string | null;
    readonly imageUrl?: string | null;
    readonly ogUrl?: string | null;
    readonly title: string;
};

const PageHeaderMetaBase = ({ canonical, children, description, imageUrl, ogUrl, title }: PageHeaderMetaProps) => {
    const safeDescription = description ?? '';
    const image = imageUrl || logoUrl;
    const ogUrlValue = ogUrl || canonical;
    const showDescription = safeDescription !== '';
    const showOgUrl = ogUrlValue !== '';

    return (
        <Helmet>
            <link
                href={canonical}
                rel="canonical"
            />
            {showDescription && (
                <meta
                    content={safeDescription}
                    name="description"
                />
            )}
            <title>{title}</title>

            {showDescription && (
                <meta
                    content={safeDescription}
                    property="og:description"
                />
            )}
            <meta
                content={title}
                property="og:title"
            />
            {showOgUrl && (
                <meta
                    content={ogUrlValue}
                    property="og:url"
                />
            )}
            <meta
                content={image}
                property="og:image"
            />
            <meta
                content={image}
                property="og:image:secure_url"
            />

            {showDescription && (
                <meta
                    content={safeDescription}
                    name="twitter:description"
                />
            )}
            <meta
                content={title}
                name="twitter:title"
            />
            <meta
                content={image}
                name="twitter:image"
            />

            {children}
        </Helmet>
    );
};

export const PageHeaderMeta = React.memo<PageHeaderMetaProps>(PageHeaderMetaBase);
